import React from 'react'
import { END } from 'redux-saga'
import { wrapper } from '@/Store/index'
import { loadSelf } from '@fdn/profile_store'
import Breadcrumb from '@fdn/breadcrumb'
import Env from 'Consts/env'
import Vars from 'Consts/vars'
import Layout from 'Containers/layout'
import MetaHeader from 'Containers/meta_header'
const cookie = require('cookie')

const Contact = (props) => {
  return (
    <Layout
      home
      title="Contact"
      page_type="contact"
      self={props.storeSelf}
      is_mobile={props.isMobile}
    >
      <MetaHeader
        title="Contact"
        url={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/contact`}
      />
      <main id="main-content">
        <section id="page-heading">
          <div className="image-heading">
            <p className="text-heading">CONTACT</p>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Breadcrumb
                  is_mobile={props.isMobile}
                  breadcrumbs={["contact"]}
                  destinationUrl={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}`}
                  fontFamily="Roboto"
                />
              </div>
            </div>
          </div>
        </section>
        <section id="page-content">
          <div className="container">
            <div className="row">
              <div className="contact-box">
                <div className="description">
                  <p>
                    Hi, Thank you for visiting this page and for your interest
                    in collaborating with us 🙂
                  </p>
                  <ul>
                    <li>
                      We welcome product samples, press kits, and invitations.
                      You can send them to our office or email us at
                      <strong>
                        {' '}
                        <a href="mailto:editorial@femaledaily.com">
                          editorial@femaledaily.com
                        </a>
                      </strong>
                    </li>
                    <li>
                      We are always excited to meet and partner up with
                      entertaining people and events. Contact us through{' '}
                      <a href="mailto:partnership@femaledaily.com">
                        <strong>partnership@femaledaily.com</strong>{' '}
                      </a>
                      and we’ll talk over coffee to explore more on what we can
                      do together.&nbsp;
                    </li>
                    <li>
                      Have a piece of insider news or want to feature us in your
                      story? Feel free to email us at
                      <strong>
                        &nbsp;
                        <a href="mailto:hello@femaledaily.com">
                          hello@femaledaily.com&nbsp;
                        </a>
                      </strong>
                    </li>
                    <li>
                      For more information on Female Daily and Mommies Daily’s
                      editorial, audience, integrated sponsorships, and&nbsp;
                      advertising inquiries, also contact us at{' '}
                      <a href="mailto:sales@femaledaily.com">
                        <strong>sales@femaledaily.com</strong>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="location-map">
                  <iframe
                    title="femaledaily google map"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15863.587874643856!2d106.826434!3d-6.277275!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x952659dbe8effd70!2sFemale+Daily+Network!5e0!3m2!1sen!2s!4v1463737536947"
                    width="100%"
                    height="500"
                    frameBorder="0"
                    style={{ border: '0' }}
                  ></iframe>
                  <hr />
                  <p>
                    <strong>Female Daily Network HQ</strong>
                    <br />
                    Menara Bank Mega Lt. 7
                    <br />
                    Jl. Kapten Tendean, Mampang Prapatan
                    <br />
                    Kota Jakarta Selatan, Jakarta 12790
                    <br />
                    Phone: (+62 21) 7918-2121
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <style jsx>
        {`
          #main-content {
            margin: 24px 0 62px;
          }

          #page-heading {
            border-bottom: 1px solid #dfe3e8;
          }

          #page-content {
            padding-top: 24px;
          }

          .col.article {
            width: calc(100% - 380px);
            max-width: calc(100% - 380px);
            margin-right: 80px;
          }

          .col.sidebar-body-wrapper {
            width: 300px;
            max-width: 300px;
          }

          .article-card-wrapper {
            border-bottom: 1px solid #dfe3e8;
            padding-bottom: 20px;
            margin-bottom: 40px;
          }

          .image-heading {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            background-image: url(https://image.femaledaily.com/editorial/banner-header/header-img.png);
            background-repeat: no-repeat;
            background-size: cover;
            height: 80px;
            box-sizing: border-box;
          }

          .text-heading {
            margin: 0;
            padding: 0;
            font-family: Josefin Sans, sans-serif;
            font-weight: 600;
            font-size: 24px;
            line-height: 32px;
            color: #fff;
            text-transform: uppercase;
          }

          .contact-box {
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 20px;
            box-sizing: border-box;
            padding: 10px;
          }

          .contact-box .description p {
            font-family: Josefin Sans, sans-serif;
            font-weight: 600;
            font-size: 24px;
            color: #333;
          }

          .contact-box .description ul li {
            list-style-type: square !important;
            font-family: Roboto;
            line-height: 24px;
            font-size: 15px;
            color: #333;
          }

          .contact-box .description ul li a {
            text-decoration: none;
            cursor: pointer;
            color: #db284e;
          }

          .contact-box .location-map hr {
            height: 3px;
            width: 46px;
            background-color: #aaa;
            border: 0;
          }

          .contact-box .location-map p {
            font-family: Roboto;
            line-height: 20px;
            font-size: 15px;
            color: #333;
          }

          @media (max-width: 800px) {
            #page-heading {
              border-bottom: 0;
            }
            .col.article {
              width: 100%;
              max-width: 100%;
              margin-right: 0;
            }
            .ads-bottom-wrapper {
              margin-top: 52px;
              width: 100%;
              text-align: center;
            }
            .ads-bottom-wrapper:empty {
              margin-top: 0;
            }
            .contact-box {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </Layout>
  )
}

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ store, req, query, res }) => {
    let userAgent
    if (req) {
      // if you are on the server and you get a 'req' property from your context
      userAgent = req.headers['user-agent'] // get the user-agent from the headers
    } else {
      userAgent = navigator.userAgent // if you are on the client you can access the navigator from the window object
    }

    let is_mobile =
      !!userAgent &&
      Boolean(
        userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
        ),
      )

    let cookies,
      authorization = null,
      usrname = null

    const isServer = !!req
    if (req.headers.cookie) {
      cookies = cookie.parse(req.headers.cookie)
      authorization = cookies.token
      usrname = cookies.usrname
    }

    if (authorization) {
      await store.dispatch(
        loadSelf({
          payload: {
            api_env: process.env.NEXT_PUBLIC_NODE_ENV,
            env: Env.HEADERS,
            Authorization: authorization,
            is_server: isServer,
            is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
          },
        }),
      )
    }

    store.dispatch(END)
    await store.sagaTask.toPromise()
    let getStoreSelf =
      !!store.getState().storeSelf.data === true
        ? store.getState().storeSelf
        : []

    return {
      props: {
        isMobile: is_mobile,
        params: query,
        storeSelf: getStoreSelf,
      },
    }
  },
)

export default Contact
